<script lang="ts" setup>
const context = await useContext().fetchContext()

const { data: weekData } = await useApi('/competition/week-data', {
  query: {
    season_id: context.org.current_season.id,
  },
  key: `competition-week-data-season-${context.org.current_season.id}`,
})

const currentTabIndex = ref<number>(weekData.value?.[0]?.id ?? 0)

const tabs = computed(() => {
  return weekData.value?.map(group => ({
    label: group.name,
    value: group.id,
  })) ?? []
})

const currentTabData = computed(() => {
  return weekData.value?.filter(predicate => predicate.id === currentTabIndex.value)[0]
})
</script>

<template>
  <Card class="overflow-hidden">
    <template #title>
      {{ $t('This week') }}
    </template>
    <template #content>
      <template v-if="weekData && weekData.length > 0">
        <Tabs
          v-model:value="currentTabIndex"
          scrollable
          show-navigators
        >
          <TabList>
            <Tab
              v-for="tab in tabs"
              :key="tab.value"
              :value="tab.value"
            >
              {{ tab.label }}
            </Tab>
          </TabList>
          <TabPanels class="p-0 py-4">
            <TabPanel
              v-for="tab in tabs"
              :key="tab.value"
              :value="tab.value"
            >
              <div
                v-if="currentTabData"
                class="flex flex-col gap-2"
              >
                <h1 class="text-2xl">
                  {{ currentTabData.name }}
                </h1>
                <div class="flex flex-col gap-2">
                  <MatchesMatchCard
                    v-for="match in currentTabData.matches"
                    :key="match.id"
                    :match="match"
                  />
                </div>
              </div>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </template>
      <template v-else>
        {{ $t('No matches this week') }}
      </template>
    </template>
  </Card>
</template>
